<div class="listingActionPopover">
	<ion-list lines="none">
		<ion-item lines="none" class="link" (click)="impersonate()" *ngIf="options.impersonate === true"
			data-cy="publicAction-impersonate">
			<label class="link"><ion-icon name="id-card-outline"></ion-icon> Access Account</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="showContact()" *ngIf="options.contact === true"
			data-cy="publicAction-unpair">
			<label class="link"><ion-icon name="person-circle-outline"></ion-icon> Contact Info</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="unpair()" *ngIf="options.unpair === true"
			data-cy="publicAction-unpair">
			<label class="link"><ion-icon name="remove-circle-outline"></ion-icon> Unpair</label>
		</ion-item>
	</ion-list>
</div>